/**
 * Utility functions for smooth scrolling
 */

/**
 * Smoothly scroll to the top of the page
 * @param {string} behavior - Scroll behavior ('smooth', 'auto', 'instant')
 */
export const scrollToTop = (behavior = 'smooth') => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: behavior
    });
};

/**
 * Smoothly scroll to the top of a specific section
 * @param {string} sectionId - ID of the section to scroll to
 * @param {string} behavior - Scroll behavior ('smooth', 'auto', 'instant')
 */
export const scrollToSectionTop = (sectionId, behavior = 'smooth') => {
    const section = document.getElementById(sectionId);
    if (section) {
        const offsetTop = section.offsetTop;
        window.scrollTo({
            top: offsetTop,
            left: 0,
            behavior: behavior
        });
    }
};

/**
 * Smoothly scroll to a specific element
 * @param {string} elementId - ID of the element to scroll to
 * @param {string} behavior - Scroll behavior ('smooth', 'auto', 'instant')
 */
export const scrollToElement = (elementId, behavior = 'smooth') => {
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({
            behavior: behavior,
            block: 'start',
            inline: 'nearest'
        });
    }
};

/**
 * Smoothly scroll to the top of a specific section
 * @param {string} sectionId - ID of the section to scroll to
 * @param {string} behavior - Scroll behavior ('smooth', 'auto', 'instant')
 */
export const scrollToSection = (sectionId, behavior = 'smooth') => {
    const section = document.getElementById(sectionId);
    if (section) {
        const offsetTop = section.offsetTop;
        window.scrollTo({
            top: offsetTop,
            left: 0,
            behavior: behavior
        });
    }
}; 